import React, { FC } from "react";
import { useLogout } from "@hooks/useLogout";
import { Menu } from "@design-system/Menu/Menu.lib";
import { ChildrenProps } from "../../types";
import styles from "./NavigationDropdown.module.scss";

interface NavigationDropdownProps extends ChildrenProps {
    toggle: React.ElementType;
    header?: React.ReactNode;
}

export const NavigationDropdown: FC<NavigationDropdownProps> = ({
    toggle: Toggle,
    header,
    children,
}) => {
    const logout = useLogout();

    return (
        <div className={styles.dropdown}>
            <Menu.Root
                trigger={<Menu.Trigger render={<Toggle />} nativeButton />}
                classNames={{ popup: styles.dropdownMenu }}
            >
                {header ? (
                    <>
                        {header}
                        <Menu.Separator />
                    </>
                ) : null}

                {children}

                <Menu.Separator />
                <Menu.Item onClick={logout}>Log out</Menu.Item>
            </Menu.Root>
        </div>
    );
};
